import { render } from "./Techno.vue?vue&type=template&id=4706543d"
import script from "./Techno.vue?vue&type=script&lang=js"
export * from "./Techno.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/ak-dev/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__